<div class="news-grid">
  <div class="gradient-details">
    <div class="div-details">
      <span class="span-details pointer" (click)="openDetails()">Saiba mais</span>
      <mat-icon svgIcon="goback" class="icon-details" (click)="openDetails()"></mat-icon>
    </div>
  </div>
  <div class="row">
    <div class="col-1 div-date">
      <div class="div-day">
        {{date | date:'dd'}}
      </div>
      <div class="div-month">
        {{date | date:'MMM'}}
      </div>
      <div class="div-year">
        {{date | date:'yyyy'}}
      </div>
    </div>
    <div class="col-11 div-info">
      <div class="div-agency">
        <span class="span-agency">{{new?.agencyDescription}}</span>
        <span class="span-time">{{date | date:'HH:mm:ss'}}</span>
        <!-- <span class="span-time">{{new.newsDate | slice:-8}}</span> -->
      </div>
      <div class="div-title">
        <a class="pointer" (click)="openDetails()">
          {{new?.title}}
        </a>
      </div>
      <div class="div-desc">
        <!-- {{new?.description.length > 150 ? (new?.description  | slice : 0 : 150) + '...' : new?.description}} -->
        {{description.length > 150 ? (description | slice : 0 : 150) + '...' : description}}
        <!-- <pre [innerHTML]="new.description"></pre> -->
      </div>
    </div>
  </div>
</div>
